export default "__VITE_ASSET__DlC22ceg__"